// src/hooks/results/useCardiopulmonaryResults.js
import { useMeasurementResults } from "./useMeasurementResults";

export function useCardiopulmonaryResults(
  db,
  uid,
  { pageSize = 50 } = {},
) {
  return useMeasurementResults(db, uid, {
    collectionName: "RecordingTidalBreathing",
    pageSize,
  });
}
